import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { LocationGroupCreateForm } from '../../modules/location-groups/location-group-create-form.js';

export const Route = createFileRoute('/warehouses/new')({
  component: NewWarehousePage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewWarehousePage() {
  return (
    <RouteGuard route="/warehouses/new">
      <LocationGroupCreateForm />
    </RouteGuard>
  );
}
